// extracted by mini-css-extract-plugin
export var topic = "topics-module--topic--dyJGs";